import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import applicationRoutes from '../../../constants/applicationRoutes.ts';
import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import Layout from '../../../app/Layout.tsx';

export const AgentEmailNavItems: RouteItem = {
  text: 'Agent Emails',
  layout: <Layout />,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [ApplicationRoles.reservations],

  subItems: [
    {
      text: 'Inbox',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: applicationRoutes.agent.inbox,
      additionalPaths: [`${applicationRoutes.agent.inbox}/:id`],
      allowedRoles: [ApplicationRoles.reservations],
      async lazy() {
        const component = await import('../../../features/agentInbox/AgentInbox.tsx');
        return { Component: component.default };
      }
    },

    {
      text: 'Frontier Quick Docs',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: [],
      path: applicationRoutes.admin.quickDocuments,
      async lazy() {
        const component = await import('../../../features/quickDocuments/QuickDocumentManagement.tsx');
        return { Component: component.QuickDocumentManagement };
      }
    }
  ]
};
